import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';


const styles = theme => ({
  switchBase: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $bar': {
        backgroundColor: '#3E82F7',
      },
    },
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
  },
  checked: {
    transform: 'translateX(20px)',
    '& + $bar': {
      opacity: 1,
      border: 'none',
    },
  },
  bar: {
    borderRadius: 9,
    width: 42,
    height: 18,
    marginTop: -9,
    marginLeft: -18,
    backgroundColor: '#3E82F7',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border']),
  },
  icon: {
    width: 14,
    height: 14,
  },
  iconChecked: {
    boxShadow: theme.shadows[1],
  },
});



const CustomSwitch = ({classes, ...props}) => (
  <Switch
    classes={{
      switchBase: classes.switchBase,
      bar: classes.bar,
      icon: classes.icon,
      iconChecked: classes.iconChecked,
      checked: classes.checked,
    }}
    disableRipple
    {...props}
  />
);

export default withStyles(styles) (CustomSwitch);


// WEBPACK FOOTER //
// ./src/components/CustomSwitch.js